module.exports = __webpack_public_path__ + "static/media/empty_image_insta.57579770.svg";